<template>
  <b-col style=" width: 100%">
    <div>
      <b-col class="col-12 d-flex title-container">
        <div class="title">{{ data.title }}</div>
        <font-awesome-icon icon="fa-solid fa-ellipsis" class="options-icon" @click="toggleOpen" />
      </b-col>
      <div v-show="isOpen" class="options-container">
        <div class="options-item edit" @click="openRenameModal">
          <div class="d-flex align-items-center profile-menu-item">
            <font-awesome-icon icon="fa-solid fa-pencil" class="list-icon mx-3" />
            Átnevezés
          </div>
        </div>
        <div class="options-item delete" @click="openDeleteModal">
          <div class="d-flex align-items-center profile-menu-item">
            <font-awesome-icon icon="fa-solid fa-trash" class="list-icon mx-3" />
            Lista törlése
          </div>
        </div>
      </div>
      <div class="my-3">
        {{ data.categoryObj.mainCategory.title }} >
        <span class="text-green">{{ data.categoryObj.subCategory.title }}</span>
      </div>
      <div class="my-2">
        <strong>
          Utoljára módosítva:
        </strong>
        {{ data.lastModifiedDate.split('T')[0] }}
      </div>

      <b-button class="mt-3" variant="primary" @click="goToFundMap">Lista megtekintése</b-button>
    </div>
    <b-modal :id="`${data._id}-rename-fund-list-modal`" hide-header hide-footer title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center"><strong> Forráslista átnevezése</strong></h1>
        <div class=" my-5" style="margin: 0 auto;">
          <h5 class="text-center">Forráslista neve</h5>
          <b-form-input
            id="newTitle"
            v-model="newTitle"
            class="col-6"
            placeholder="Adja meg a forráslista új nevét."
            trim
          ></b-form-input>
        </div>
        <div class="d-flex justify-content-center">
          <b-button class="mr-2" @click="closeRenameModal">Mégsem</b-button>
          <b-button class="ml-2" @click="handleRename">Átnevezés</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :id="`${data._id}-delete-fund-list-modal`" hide-header hide-footer title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center text-center mb-5">
          <strong> Biztos benne, hogy törli a forráslistát?</strong>
        </h1>

        <div class="d-flex justify-content-center">
          <b-button class="mr-2 col-2" @click="handleDelete">Igen</b-button>
          <b-button class="ml-2 col-2" @click="closeDeleteModal">Mégsem</b-button>
        </div>
      </div>
    </b-modal>
  </b-col>
</template>
<script>
import * as SearchObjectApi from '../../../api/searchObject'
import successToast from '../../../mixins/toastSuccess'
import errorToast from '../../../mixins/toastError'
import { regex } from '../../../regex/regex'
export default {
  mixins: [successToast, errorToast],
  name: 'FavouriteFundListDetails',
  props: {
    data: { type: Object, required: true }
  },
  data: function() {
    return {
      isOpen: false,
      isRenameModalOpen: false,
      newTitle: ''
    }
  },
  methods: {
    validateField(value) {
      return regex.test(value)
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    async handleDelete() {
      await SearchObjectApi.deleteSearchObjectsById(this.data._id)
      this.$emit('search-object-change', true)
      this.closeDeleteModal()
    },
    async handleRename() {
      const isValid = this.validateField(this.newTitle)

      if (!isValid) {
        return this.errorToast(`A következő karakterek használata nem engedélyezett. (< > ; ' ")`)
      }
      await SearchObjectApi.patchSearchObjectsById(this.data._id, {
        title: this.newTitle
      })
      this.$emit('search-object-change', true)
      this.closeRenameModal()
      this.successToast('A mentés sikeres volt!')
    },
    openDeleteModal() {
      this.$root.$emit('bv::show::modal', this.data._id + '-delete-fund-list-modal')
    },
    closeDeleteModal() {
      this.$root.$emit('bv::hide::modal', this.data._id + '-delete-fund-list-modal')
    },
    openRenameModal() {
      this.$root.$emit('bv::show::modal', this.data._id + '-rename-fund-list-modal')
    },
    closeRenameModal() {
      this.$root.$emit('bv::hide::modal', this.data._id + '-rename-fund-list-modal')
    },
    addCompanyAttribute(key, value) {
      this.$store.dispatch('setCompanyAttributeAction', { [key]: value })
    },
    async goToFundMap() {
      this.$store.dispatch('toggleTriggerNextButtonAction')

      const getCompanyQueryParams = { value: this.data.companyId }
      await this.$store.dispatch('getFundMapCompanyAction', getCompanyQueryParams)

      if (this.data.filters.teaor) {
        this.addCompanyAttribute('teaor', this.data.filters.teaor)
      }
      if (this.data.filters.zip) {
        this.addCompanyAttribute('zip', this.data.filters.zip)
      }
      if (this.data.filters.revenue) {
        this.addCompanyAttribute('revenue', this.data.filters.revenue)
      }
      if (this.data.filters.balanceSheetTotal) {
        this.addCompanyAttribute('balanceSheetTotal', this.data.filters.balanceSheetTotal)
      }
      if (this.data.filters.financeData) {
        this.addCompanyAttribute('financeData', this.data.filters.financeData)
      }
      if (this.data.filters.head_count) {
        this.addCompanyAttribute('head_count', this.data.filters.head_count)
      }
      if (this.data.filters.latestExportRevenue) {
        this.addCompanyAttribute('latestExportRevenue', this.data.filters.latestExportRevenue)
      }

      if (this.data.filters.restrictions) {
        this.addCompanyAttribute('restrictions', this.data.filters.restrictions.competitionIds)
      }

      if (this.data.filters.revenueFromAggriculture) {
        this.addCompanyAttribute('revenueFromAggriculture', this.data.filters.revenueFromAggriculture)
      }
      if (this.data.filters.isSupplier) {
        this.addCompanyAttribute('isSupplier', this.data.filters.isSupplier)
      }
      if (this.data.categoryObj) {
        this.$store.dispatch('selectFundMapCategoryAction', this.data.categoryObj)
      }

      this.$store.dispatch('resetStepsAction')
      this.$store.dispatch('nextStepAction')
      this.$router.push(`/fund-map/search?companyId=${this.data.companyId}`)
    }
  }
}
</script>
<style scoped>
.title-container {
  position: relative;
  padding-left: 0px !important;
  margin-bottom: 24px;
}
.title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #00903c;
}

.options-icon {
  position: absolute;
  font-size: 24px;
  right: 0px;
  cursor: pointer;
}

.list-icon {
  width: 16px;
  height: 16px;
}

.options-container {
  position: absolute;
  z-index: 999;
  right: 0;
  top: 30px;
  text-align: left;

  background: #ffffff;
  border: 1px solid #dfe2ea;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 25px rgba(0, 0, 0, 0.07);
  border-radius: 8px;

  width: 250px;
  height: auto;
}

.options-item {
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

.options-item.delete:hover {
  background: #fbd0d4;
  color: #ba3b46;
}

.options-item.edit:hover {
  background: #cce9d8;
  color: #00903c;
}
</style>
